// extracted by mini-css-extract-plugin
module.exports = {"topicTitle":"topicTitle-1uV-AIKv","titleLogo":"titleLogo-348NyMS-","titleTxt":"titleTxt-25nGk2Zk"};